import { Button } from "@mui/joy";
import { PatientType } from "api/patientApi";
import useEnableTaskUpdateRequired from "hooks/useEnableTaskUpdateRequired";

export default function AddUpdateRequiredButton({
  patient,
}: {
  patient: PatientType;
}) {
  const { allowed, enable } = useEnableTaskUpdateRequired(patient);

  return (
    <Button
      variant={"Outlined"}
      disabled={!allowed}
      onClick={() => {
        enable();
      }}
    >
      업데이트 필요 목록에 넣기
    </Button>
  );
}
